import React from "react";
import Sideform from "../Sideform";
import ShareButtons from "../../../utility/ShareButtons";
import FAQAccordion from "../../../utility/FAQAccordion";
import QuickNavigation from "../../../utility/serviceTemplateutility/QuickNavigation";
import CardDesign from "../../../utility/serviceTemplateutility/CardDesigntwo";
import MultiStepForm from "../../../utility/serviceTemplateutility/MultiStepForm";
import WhyUs from "../../../utility/serviceTemplateutility/WhyUs";
import OurTeam from "../../homepage/OurTeam";
import Testimonials from "../../homepage/Testimonials";
import { useGlobalData } from "../../../contextApi/globalContextData";

const BloodTest = () => {
  const serviceUrl = window.location.href;
  const { sectionsData } = useGlobalData();
  const faqData = [
    { heading: "Frequently Asked Questions" },
    {
      question: "Can blood tests be done at home?",
      answer:
        "Yes, blood tests can be done at home with professional testing services for accurate results delivered to your doorstep.",
    },
    {
      question: "Can you test your blood type at home?",
      answer:
        "Yes, you can test your blood type at home through specialized home testing kits for accurate results.",
    },
    {
      question: "How can I book a blood test at home?",
      answer:
        "Book easily via the website, WhatsApp, or by calling. Select your test and schedule, a professional will visit your location.",
    },
    {
      question:
        "Is it possible to complete a blood count CBC blood test at home?",
      answer:
        "Yes, Elite Body Home provides at-home CBC blood tests. A trained professional will visit your home to collect the sample, ensuring accurate results with minimal hassle.",
    },
    {
      question: "Are Blood Tests at Home accurate and reliable?",
      answer:
        "Yes, Blood Tests at Home can be accurate and reliable when performed correctly and when samples are sent to accredited laboratories.",
    },
  ];

  const steps = [
    { heading: "Lab Test at Home Process Just in 4 Easy Steps!" },
    {
      title: "Make A Call",
      description:
        "Make a call and book your appointment online or via phone. Our homecare expert will assist you.",
      iconClass: "fa-solid fa-phone",
    },
    {
      title: "Certified Nurse At Your Place",
      description:
        "Our experienced DHA-certified nurse will visit your place at the scheduled time, carrying all necessary equipment.",
      iconClass: "fa-solid fa-user-nurse",
    },
    {
      title: "Sample Collection",
      description:
        "Nurse will collect the blood sample. The process is quick, typically taking no more than 10–15 minutes.",
      iconClass: "fa-solid fa-vial",
    },
    {
      title: "Result Delivery",
      description:
        "Same day your results will be delivered electronically via email or through a secure online portal.",
      iconClass: "fa-solid fa-file-medical",
    },
  ];

  const benefitsData = [
    { heading: "Benefits of Blood Test at Home" },
    {
      para: "Opting for a home blood test offers numerous advantages, making it a preferred choice for many patients. Here’s why this service stands out",
    },
    {
      id: 1,
      title: "Convenience",
      description:
        "No need to travel or wait in long queues. Get your blood test done at a time and place that suits you.",
      icon: "fa-solid fa-calendar-check",
    },
    {
      id: 2,
      title: "Comfort",
      description:
        "Especially beneficial for elderly patients, children, or those with disabilities who find it challenging to travel.",
      icon: "fa-solid fa-bed",
    },
    {
      id: 3,
      title: "Time-Saving",
      description:
        "Avoid long waiting times at labs or clinics; the entire process is quick and efficient.",
      icon: "fa-solid fa-clock",
    },
    {
      id: 4,
      title: "Privacy",
      description:
        "Enjoy a discreet and private testing experience, especially for those who prefer avoiding public spaces.",
      icon: "fa-solid fa-user-secret",
    },
    {
      id: 5,
      title: "Flexibility",
      description:
        "Appointments can be scheduled early in the morning or late in the evening, fitting seamlessly into your routine.",
      icon: "fa-solid fa-calendar-alt",
    },
    {
      id: 6,
      title: "Reduced Infection Risk",
      description:
        "Minimizes exposure to public environments, which is especially important for individuals with compromised immune systems.",
      icon: "fa-solid fa-shield-alt",
    },
  ];

  return (
    <>
      <title>Blood Test at Home in Dubai - Quick, &amp; Reliable Result</title>
      <meta
        name="description"
        content="Get accurate blood test at home in Dubai. Choose from 3500+ tests, including blood and advance STD tests, with reliable lab test results delivered to your doorstep. Book now!"
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/services/blood-test-at-home-dubai/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Blood Test at Home in Dubai - Quick, &amp; Reliable Result"
      />
      <meta
        property="og:description"
        content="Get accurate blood test at home in Dubai. Choose from 3500+ tests, including blood and advance STD tests, with reliable lab test results delivered to your doorstep. Book now!"
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/blood-test-at-home-dubai/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-02-15T14:01:16+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-70.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-70.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="blood test at home" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Blood Test at Home in Dubai - Quick, &amp; Reliable Result"
      />
      <meta
        name="twitter:description"
        content="Get accurate blood test at home in Dubai. Choose from 3500+ tests, including blood and advance STD tests, with reliable lab test results delivered to your doorstep. Book now!"
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-70.jpg"
      />
      <div className="min-vh-100 font-sans text-dark mb-5 mx-3">
        <div className="container-fluid px-0 py-4">
          <div className="row justify-content-center">
            <div>
              <div
                className="rounded-4 overflow-hidden shadow-sm"
                style={{ border: "2px solid #c69933" }}
              >
                <div className="row g-0 align-items-stretch">
                  {/* Image Column - Left Side */}
                  <div className="col-lg-6">
                    <img
                      loading="lazy"
                      decoding="async"
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/blood-test-dubai-large.jpg"
                      className="img-fluid w-100 h-100 object-fit-cover"
                      alt="Aqualyx fat dissolving injections in Dubai | Elite Body Home"
                      style={{
                        minHeight: "400px",
                        maxHeight: "720px",
                      }}
                    />
                  </div>

                  {/* Content Column - Right Side */}
                  <div className="col-lg-6 d-flex align-items-center bg-white">
                    <div
                      className="p-4 p-md-5 w-100"
                      style={{ maxWidth: "600px", margin: "0 auto" }}
                    >
                      <h1
                        className="display-5 fw-bold mb-3"
                        style={{
                          color: "#c69933",
                        }}
                      >
                        Blood Test at Home in Dubai
                      </h1>
                      <ul>
                        <li>Highest Quality of Homecare</li>
                        <li>CAP-accredited Laboratories</li>
                        <li>DHA Qualified Nurses</li>
                        <li>Anywhere in Dubai</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-2 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/home">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Services
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Blood Test at Home in Dubai
                </li>
              </ol>
            </nav>
            <QuickNavigation />
            <div>
              <h2 className="title">
                Access Premium Lab Services from the Comfort of Your Home
              </h2>
            </div>
            <div>
              <p>
                Why go out for a blood test when it can come to you? Elite Body
                Home offers blood test at home services, making health checks
                simple, safe, and stress-free. Skip the waiting rooms and enjoy
                the convenience of accurate, reliable results from the comfort
                of your home. Whether it’s for regular wellness checks or
                specialized tests, our experienced team ensures a smooth,
                friendly experience, helping you stay informed and in control of
                your health—easily and comfortably.
              </p>
              <p>
                <strong>
                  In partnership with Dubai’s most reputable CAP-accredited
                  Laboratories, Elite Body Home is proud to be the exclusive
                  provider offering expert medical correlation of all your
                  results, under the supervision of a DHA-licensed pathologist.
                  Your health, our priority!
                </strong>
              </p>
            </div>
            <section id="packages" class="py-5 bg-light">
              <div class="container">
                <div class="mb-4 text-center">
                  <h2 class="fw-bold">
                    Get Convenient Blood Test Services Delivered to Your Home in
                    Dubai
                  </h2>
                  <p class="text-muted">
                    Our team of highly skilled, DHA-certified nurses is
                    dedicated to providing accurate and reliable diagnostic
                    support for you and your family. Available every day of the
                    year, we proudly serve the blood test at home service in
                    Dubai region, ensuring quality healthcare is always within
                    reach.
                  </p>
                </div>

                <div class="mb-5">
                  <h3 class="fw-semibold mb-3">
                    Individuals Test (More Than 2000)
                  </h3>
                  <div class="row">
                    <div class="col-md-4">
                      <ul class="list-unstyled">
                        <li>Allergy Test</li>
                        <li>Anaemia Test</li>
                        <li>Blood Sugar Test</li>
                        <li>Complete Blood Count</li>
                        <li>CRP</li>
                        <li>PCR Test</li>
                        <li>Cholesterol Test</li>
                        <li>Diabetes Test</li>
                        <li>Electrolytes</li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/food-intolerance-test/"
                            target="_blank"
                          >
                            Food Intolerance Test
                          </a>
                        </li>
                        <li>Food Sensitivity Test</li>
                      </ul>
                    </div>
                    <div class="col-md-4">
                      <ul class="list-unstyled">
                        <li>HbA1C Test</li>
                        <li>Hepatitis A</li>
                        <li>Hepatitis B</li>
                        <li>Hormone Test</li>
                        <li>Infertility Test</li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/blog/influenza-flu-vaccine-benefits-side-effects-manage/"
                            target="_blank"
                          >
                            Influenza Test
                          </a>
                        </li>
                        <li>Kidney Function Test</li>
                        <li>Lipid Profile</li>
                        <li>Liver Function Test</li>
                        <li>HIV Test</li>
                        <li>Microbial Culture & Sensitivity Test</li>
                      </ul>
                    </div>
                    <div class="col-md-4">
                      <ul class="list-unstyled">
                        <li>Mineral Test</li>
                        <li>Pregnancy Test</li>
                        <li>Renal Function Test</li>
                        <li>Stool Test</li>
                        <li>Semen Test</li>
                        <li>Sexual Health Test</li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/testosterone-test/"
                            target="_blank"
                          >
                            Testosterone Test
                          </a>
                        </li>
                        <li>Urine Test</li>
                        <li>Vitamins Test</li>
                        <li>NIPT Test</li>
                        <li>
                          <a
                            href="https://elitebodyhome.com/std-test-dubai/"
                            target="_blank"
                          >
                            STD Test
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div>
                  <h3 class="fw-semibold mb-3">
                    Comprehensive Packages (More Than 1500)
                  </h3>
                  <div class="row">
                    <div class="col-md-4">
                      <ul class="list-unstyled">
                        <li>Respiratory Infections Panel</li>
                        <li>Food Allergies and Intolerance Tests</li>
                        <li>Basic Wellness Blood Package</li>
                        <li>Comprehensive Health Checkup</li>
                        <li>Fertility & Infertility Tests</li>
                        <li>Sexual Wellness Screening</li>
                        <li>Cardiac Function Tests</li>
                        <li>Cancer Markers Packages</li>
                        <li>Fitness Analysis & Profile</li>
                        <li>Extensive Hair Loss Tests</li>
                        <li>Extensive STD Tests and Packages</li>
                        <li>HPV Molecular Tests</li>
                        <li>General Full Body Checkup</li>
                      </ul>
                    </div>
                    <div class="col-md-4">
                      <ul class="list-unstyled">
                        <li>Comprehensive Full Body Check-up</li>
                        <li>Fatigue Blood Package</li>
                        <li>Pre-Marital Health Blood Test</li>
                        <li>Fitness Checkup Package</li>
                        <li>Hair Loss Package</li>
                        <li>Obesity Health Package</li>
                        <li>Skin Health Checkup Package</li>
                        <li>Urinary Tract Infection Package</li>
                        <li>Gut Healer Package</li>
                        <li>Cardiac Package</li>
                        <li>Vitamin & Mineral Package</li>
                        <li>Stress Relief Package</li>
                        <li>Pre-Operational Package</li>
                      </ul>
                    </div>
                    <div class="col-md-4">
                      <ul class="list-unstyled">
                        <li>Anemia Package – I</li>
                        <li>Anemia Package – II</li>
                        <li>Basic Thyroid Package</li>
                        <li>Comprehensive Thyroid Package</li>
                        <li>Diabetic Package</li>
                        <li>Coagulation Profile</li>
                        <li>Insulin Resistance Profile</li>
                        <li>Drugs of Abuse Screen</li>
                        <li>Antenatal Screen</li>
                        <li>Hepatitis B Profile</li>
                        <li>Hepatitis Screen</li>
                        <li>Celiac Profile – Basic</li>
                        <li>Celiac Profile – Comprehensive</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div id="procedures">
              <CardDesign carditems={steps} />
            </div>

            <div id="benefits">
              <CardDesign carditems={benefitsData} />
            </div>

            <section className="container py-5">
              <div className="title mb-4">
                <h2>
                  Experience Elite Care with Premium At Home Blood Test Services
                  in Dubai
                </h2>
              </div>

              <div className="row align-items-center">
                <div className="col-md-6 mb-4 mb-md-0">
                  <img
                    src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/lab-large.jpg"
                    alt="Blood Test Dubai"
                    className="img-fluid rounded shadow"
                  />
                </div>

                <div className="col-md-6">
                  <p>
                    Why settle for the ordinary when you can experience the
                    extraordinary? At Elite Body Home, we believe your health
                    deserves a premium approach. Our blood test at home service
                    is designed not just for convenience but to redefine how you
                    experience diagnostics. From the moment our DHA-licensed
                    professionals arrive at your door to the precision-driven
                    results verified by certified doctors, every step is
                    tailored to your comfort and confidence.
                  </p>
                  <p>
                    We don’t just collect samples; we deliver peace of mind with
                    state-of-the-art equipment,{" "}
                    <strong>internationally accredited labs</strong>, and
                    personalized follow-ups. Whether it’s a routine test or
                    urgent diagnostics, Elite Body Home ensures healthcare that
                    fits seamlessly into your lifestyle—on your schedule, at
                    your doorstep.
                  </p>
                </div>
              </div>
            </section>

            <WhyUs language="en" />
            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials data={sectionsData["Success Stories"]} />
            <FAQAccordion faqData={faqData} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
};

export default BloodTest;
